/**
 * Returns the single post template as a string
 *
 * @param data The data for this post
 */
export function singlePostTemplate(post: SinglePostJSON): string {
    return `
        <main class="c-single-post">
            <button type="button" class="c-single-post__close js-single-post__close"><svg width="16" height="16"><use xlink:href="#svg-cross"></use></svg></button>

            <div class="c-single-post__header u-last-child">
                <svg class="c-single-post__header-logo-mark c-single-post__header-logo-mark--${ post.data.material_type_class }" width="100%" height="100%"><use xlink:href="#svg-logo-mark"></use></svg>
                <div class="u-pos-relative">
                    <p class="c-single-post__logo"><img src="${ post.data.material_type_logo.src }" alt="${ post.data.material_type_logo.alt }" /></p>
                    <p class="o-subtitle">${ post.data.subtitle }</p>
                    <h1 class="u-gamma">${ post.data.title }</h1>
                </div>
            </div>

            ${ post.data.gallery.length > 0 ? `
                <div class="c-single-post__gallery o-flickity js-single-post__gallery">

                    ${ post.data.gallery.map(media => `

                        <div class="o-flickity__slide c-single-post__gallery-item">
                            <img class="o-bg u-fill" src="${ media.url }" alt="${ media.alt }" srcset="${ media.srcset }" sizes="(min-width: 740px) 760px, (min-width: 980px) 900px, (min-width: 1300px) 980px, 100vw" />
                        </div>

                    `).join('')}

                </div>
            ` : `` }

            <div class="c-single-post__content u-auto-headings">

                <div class="c-single-post__text-content">${ post.data.content }</div>

                ${ post.data.downloads.length > 0 ? `
                    <div class="c-single-post__downloads">
                        <p class="o-subtitle c-single-post__downloads-title">${ post.data.strings.downloads }</p>

                        <div class="o-layout o-layout--center">

                            ${ post.data.downloads.map(media => `

                                <div class="o-layout__item u-6/12@tablet">
                                    <p><a href="${ media.url }" download class="o-btn o-btn--secondary u-12/12">${ media.name }</a></p>
                                </div>

                            `).join('')}

                        </div>
                    </div>
                ` : `` }

                <p class="c-single-post__cta"><a class="o-btn" href="${ post.data.contact_url }">${ post.data.strings.contact }</a></p>

                <div class="c-single-post__share c-sharing-links">
                    <p class="c-sharing-links__label o-subtitle js-fade-slide-up__item">${ post.data.strings.share }</p>
                    <ul class="c-sharing-links__links o-icn-link-list o-icn-link-list--small">
                        <li class="o-icn-link-list__item js-fade-slide-up__item"><a title="${ post.data.strings.share_twitter }" class="o-icn-link-list__link js-new-window" href="${ post.data.share_urls.twitter }" target="_blank" rel="noopener"><svg width="20" height="20"><use xlink:href="#svg-twitter"></use></svg></a></li>
                        <li class="o-icn-link-list__item js-fade-slide-up__item"><a title="${ post.data.strings.share_linkedin }" class="o-icn-link-list__link js-new-window" href="${ post.data.share_urls.linkedin }" target="_blank" rel="noopener"><svg width="20" height="20"><use xlink:href="#svg-linkedin"></use></svg></a></li>
                        <li class="o-icn-link-list__item js-fade-slide-up__item"><a title="${ post.data.strings.share_pinterest }" class="o-icn-link-list__link js-new-window" href="${ post.data.share_urls.pinterest }" target="_blank" rel="noopener"><svg width="20" height="20"><use xlink:href="#svg-pinterest"></use></svg></a></li>
                        <li class="o-icn-link-list__item js-fade-slide-up__item"><a title="${ post.data.strings.share_facebook }" class="o-icn-link-list__link js-new-window" href="${ post.data.share_urls.facebook }" target="_blank" rel="noopener"><svg width="20" height="20"><use xlink:href="#svg-facebook"></use></svg></a></li>
                        <li class="o-icn-link-list__item js-fade-slide-up__item"><a title="${ post.data.strings.share_whatsapp }" class="o-icn-link-list__link js-new-window" href="${ post.data.share_urls.whatsapp }" target="_blank" rel="noopener"><svg width="20" height="20"><use xlink:href="#svg-whatsapp"></use></svg></a></li>
                    </ul>
                </div>
            </div>
        </main>
    `;
}


/**
 * Returns a news box as a string
 * 
 * @param post The box data
 */
export function postsBoxTemplate(post: PostData): string {
    return `
        <div class="o-layout__item u-6/12@tablet js-latest__item">
            <div class="c-news-box c-news-box--${ post.post_style } js-fade-slide-up__item">
                <a href="${ post.post_permalink }" class="c-news-box__link js-latest__news-item-link">

                    ${ 'text_image' === post.post_style ? `
                        <img class="o-bg u-fill" src="${ post.image.url }" alt="${ post.image.alt }" srcset="${ post.image.srcset }" sizes="(min-width: 740px) 410px, (min-width: 980px) 470px, 100vw" />
                    ` : ``}
                    
                    <p class="c-news-box__icn"><svg class="c-news-box__icn-graphic" width="16" height="16"><use xlink:href="#svg-document"></use></svg></p>

                    <div class="c-news-box__inner u-last-child">
                        <p class="o-subtitle c-news-box__subtitle">${ post.subtitle }</p>
                        <h2 class="u-delta c-news-box__title">${ post.title }</h2>
                    </div>

                    <p class="c-news-box__btn">${ post.strings.read_more }</p>

                </a>
            </div>
        </div>
    `;
}
